const AnjuDjSetsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://soundcloud.com/eauxminy/club-kawaii-meauxminy-guest-spot" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-p8ru6SzyL81sWu3L-ODcRvQ-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Meauxminy @ Club Kawaii (Hosted by ANJU Online!)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://soundcloud.com/anjuonline/deeply-online" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-7iavQKWSXJbeeOz9-N8dpMQ-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Deeply Online (Full Set)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://www.youtube.com/watch?v=Oa17vu2-w2E" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-PwqCZJx2omOIloxP-81g7Pw-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Hellscape Radio Vol. 6</strong> - Hellscape Digital @ CRACKFEST VI<br/>
                (Hosted by ANJU Online!)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://www.youtube.com/watch?v=444jIQF-mRU" target="_blank" rel="noopener noreferrer">
              <img src="https://i.imgur.com/hA2r41r.png" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Hellscape Radio Vol. 4</strong><br/>Kawaii Ry & ANJU Online! @ CG Fest 2023
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://soundcloud.com/anjuonline/club-kawaii" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-vejMf4Oh790upIGy-zsTVPA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ANJU Online! @ Club Kawaii</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://soundcloud.com/anjuonline/dreamworld-festival" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-DNsLZpz5kUp9Qsly-PNoxbg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ANJU Online! @ DREAMWORLD Festival</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://www.youtube.com/watch?v=kXeKwQsEtg4" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-oRXsFL7pajM9zxnU-yDhLaA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Hellscape Radio Vol. 3</strong><br/>
                (Hosted by ANJU Online!)
              </p>
            </a>
          </div>             

          <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://www.youtube.com/watch?v=WP598fnjOMM" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-tF08flAkDpvmjgof-uvDVsg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Hellscape Radio Vol. 2</strong><br/>
                (Hosted by ANJU Online!)
              </p>
            </a>
          </div>          

          <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://www.youtube.com/watch?v=63cbQdzd_oo" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000594396492-7c85fj-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Hellscape Radio Vol. 1</strong><br/>
                (Hosted by ANJU Online!)
              </p>
            </a>
          </div>             

        </div>
      </>
    );
  };
  export default AnjuDjSetsStatic;